import { AvailableServicesType } from './relay-types';

export const getAvailableServices = async ({
    availableServicesUrl,
    authToken,
}: {
    availableServicesUrl: string;
    authToken: string;
}): Promise<AvailableServicesType> => {
    const response = await fetch(availableServicesUrl, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch available services: ${response.status} ${response.statusText}`);
    }

    return await response.json();
};
